import Cookies from 'js-cookie';

const micromodalOptions = {
  onShow: (modal, element, event) => {
    document.documentElement.style.overflow = 'hidden';

    const modalEvent = new CustomEvent('modal.opened', {
      detail: modal,
    });

    modal.dispatchEvent(modalEvent);
  },
  onClose: (modal, element, event) => {
    document.documentElement.style.overflow = 'auto';

    // closing modal
    if (modal.id === 'modal-login-form') {
      window.dispatchEvent(new CustomEvent('login.closed'));
    }

    console.log('Closing modal', modal);

    if (modal.id === 'call-to-action-modal') {
      console.log('Closing cta modal');

      Cookies.set('cta-shown', true);
    }

    if (modal.id.includes('promotion')) {
      window.dispatchEvent(new CustomEvent('promotion.closed'));
    }

    if (modal.id === 'modal-activity-selector' || modal.id === 'modal-booking-form') {
      window.dispatchEvent(new CustomEvent('booknow.closed'));
      window.dispatchEvent(new CustomEvent('primary.action.reset'));
    }
  },
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: false,
  awaitCloseAnimation: false,
  debugMode: true,
};

export default micromodalOptions;
